export default __webpack_public_path__ + "static/media/Profile.671bb1ed.svg";